import React, { useEffect, useState } from 'react'
import { DataSelectType } from '../../../../../models/DataSelectType';
import { getRecentYears } from '../../../../../common/GlobalFunctions';
import DinamicSelectComp from '../../../../../common/DinamicSelectComp';
import DinamicInputFilter from '../../../../../common/DinamicInputFilter';
import useCompany from '../../../../../store/ReactQueries/general/company/useCompany';
import useAssetTypes from '../../../../../store/ReactQueries/assets/assetTypes/useAssetTypes';
import useLocationsByCompId from '../../../../../store/ReactQueries/locations/useLocationByCompId';
import useAssetStatuses from '../../../../../store/ReactQueries/assets/assetStatuses/useAssetStatuses';
import useAssetCategories from '../../../../../store/ReactQueries/assets/assetCategories/useAssetCategories';
import useAssetDepartments from '../../../../../store/ReactQueries/assets/assetDepartments/useAssetDepartments';

interface AssetFilterProps {
    resetTrigger: number;
    filterData: DataSelectType[] | undefined;
    setFilterData: React.Dispatch<React.SetStateAction<DataSelectType[] | undefined>>;
}

export const AssetFilter: React.FC<AssetFilterProps> = ({ filterData, setFilterData, resetTrigger }) => {
    const [companyId, setCompanyId] = useState<string>();

    useEffect(() => {
        const companyItem = filterData?.find(item => item.field === "CompanyId");
        setCompanyId(companyItem ? companyItem.value : undefined);
    }, [JSON.stringify(filterData)]);

    useEffect(() => {
        let result = filterData?.filter(item => item.field !== 'LocationId');
        setFilterData(result);
    }, [companyId]);

    const { data: companies } = useCompany(0, 0)
    const { data: assetTypes } = useAssetTypes(0, 0);
    const { data: assetStatuses } = useAssetStatuses(0, 0);
    const { data: assetCategories } = useAssetCategories(0, 0);
    const { data: assetDepartments } = useAssetDepartments(0, 0);
    const { data: locations } = useLocationsByCompId(0, 0, companyId);

    const renderFilters: { fieldDisplayName: string, optionsData: any[] | undefined, menuPlacement?: "top" | "bottom"; }[] = [
        { fieldDisplayName: 'Year', optionsData: getRecentYears },
        { fieldDisplayName: 'AssetCategory', optionsData: assetCategories },
        { fieldDisplayName: 'AssetType', optionsData: assetTypes },
        { fieldDisplayName: 'Company', optionsData: companies },
        { fieldDisplayName: 'Location', optionsData: locations ?? [] },
        { fieldDisplayName: 'AssetDepartment', optionsData: assetDepartments },
        { fieldDisplayName: 'AssetStatus', optionsData: assetStatuses },
    ];

    return (
        <React.Fragment>
            <DinamicInputFilter
                field="Title"
                fieldDisplayName="Title"
                filterData={filterData}
                resetTrigger={resetTrigger}
                setFilterData={setFilterData}
            />
            <DinamicInputFilter
                field="Barcode"
                fieldDisplayName="Barcode"
                filterData={filterData}
                resetTrigger={resetTrigger}
                setFilterData={setFilterData}
            />
            {
                renderFilters.map(item =>
                    <DinamicSelectComp
                        key={`${item.fieldDisplayName}-asset-filter`}
                        companyId={companyId}
                        filterData={filterData}
                        resetTrigger={resetTrigger}
                        optionsData={item.optionsData}
                        menuPlacement={item.menuPlacement}
                        fieldDisplayName={item.fieldDisplayName}
                        setFilterData={setFilterData}
                    />)
            }
        </React.Fragment>
    );
}
export default AssetFilter